import { Alert } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

export interface SharedEmailPerson {
  id: number
  name: string
  membership_level: string
}

export function SharedEmailChooser({
  email,
  people,
  selecting,
  selectionFailed,
  onSelect,
}: {
  email: string
  people: SharedEmailPerson[]
  selecting: boolean
  selectionFailed: boolean
  onSelect: (contactId: number) => void
}) {
  return (
    <div>
      <div className="space-y-1.5">
        <h1 className="text-subheading font-semibold text-foreground">Who&apos;s signing in?</h1>
        <p className="text-body-sm text-muted-foreground">
          {email} belongs to more than one record.
        </p>
      </div>

      {selectionFailed && (
        <Alert className="mt-4">That choice is invalid or expired. Sign in again.</Alert>
      )}

      <div className="mt-6 space-y-2">
        {people.map((person) => (
          <Button
            key={person.id}
            type="button"
            variant="outline"
            aria-label={`${person.name}, ${person.membership_level}`}
            className="h-auto w-full justify-between px-4 py-3"
            disabled={selecting}
            onClick={() => onSelect(person.id)}
          >
            <span className="text-body-sm font-medium">{person.name}</span>
            <span className="text-caption text-muted-foreground">{person.membership_level}</span>
          </Button>
        ))}
      </div>
    </div>
  )
}
